import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export type TriggerKind = 'on_join' | 'time_on_server' | 'webhook_event';

interface Props {
  kind: TriggerKind;
  config: Record<string, unknown>;
  onKindChange: (kind: TriggerKind) => void;
  onConfigChange: (config: Record<string, unknown>) => void;
}

export function TriggerEditor({ kind, config, onKindChange, onConfigChange }: Props) {
  function update(patch: Record<string, unknown>) {
    onConfigChange({ ...config, ...patch });
  }
  return (
    <div className="space-y-3">
      <div className="space-y-1">
        <Label>Trigger</Label>
        <Select value={kind} onValueChange={(v) => onKindChange(v as TriggerKind)}>
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="on_join">On join</SelectItem>
            <SelectItem value="time_on_server">After N minutes on server</SelectItem>
            <SelectItem value="webhook_event">On webhook event</SelectItem>
          </SelectContent>
        </Select>
      </div>
      {kind === 'time_on_server' && (
        <div className="space-y-1">
          <Label>after_minutes</Label>
          <Input
            type="number"
            value={Number(config.after_minutes ?? 1440)}
            onChange={(e) => update({ after_minutes: Number(e.target.value) })}
            min={1}
          />
        </div>
      )}
      {kind === 'webhook_event' && (
        <p className="text-xs text-muted-foreground">
          A unique URL and HMAC secret will be generated when you save this rule. External services
          POST to that URL with{' '}
          <code className="rounded bg-muted px-1">{`{ "discord_id": "..." }`}</code> to grant this
          role.
        </p>
      )}
      {kind === 'on_join' && (
        <p className="text-xs text-muted-foreground">
          Fires immediately when a user joins the server.
        </p>
      )}
    </div>
  );
}
